<div class="user-requests-container" style="padding-bottom: var(--footer-height, 56px); box-sizing: border-box;">
  <app-table
    [data]="requestData"
    [columns]="requestColumns"
    [rows]="requestPageSize"
    [totalRecords]="requestTotalRecords"
    [showPaginator]="true"
    (lazyLoadData)="onLazyLoadEventFromTable($event)"
    [showSort]="false"
    [showFilter]="true"
    [loading]="requestLoading"
    [globalFilterFields]="requestGlobalFilterFields"
    [actions]="requestActions"
    [filterConfig]="requestFiltersConfig"
    [(filterValue)]="requestFiltersValue"
    (searchClicked)="onRequestsSearchClicked($event)"
    (viewCertificateEvent)="onViewCertificate($event)"
  >
    <ng-template pTemplate="body" let-row>
      <!-- Hide Action buttons for rejected statuses -->
      <ng-container *ngIf="!row.hideActions">
        <div class="action-buttons">
          <!-- Buttons for Actions -->
        </div>
      </ng-container>
    </ng-template>
  </app-table>

  <!-- Anchored list popup (dialog) -->
  <dialog class="list-popup" [open]="listPopupVisible" [style.left.px]="listPopupX" [style.top.px]="listPopupY" aria-label="More items">
    <div class="popup-header">
      <span>{{ listPopupTitle }}</span>
      <button type="button" aria-label="Close" (click)="closeListPopup()">✕</button>
    </div>
    <ul class="popup-list">
      <li *ngFor="let c of listPopupItems">{{ c }}</li>
    </ul>
  </dialog>
</div>

<app-accept-request-popup
  [(visible)]="showGenericSuccessDialog"
  (onClose)="onGenericSuccessDialogClose()"
></app-accept-request-popup>

<app-decline-request-popup
  [(visible)]="showDeclineRequestDialog"
  (declineConfirmed)="onDeclineConfirmed($event)"
  (visibleChange)="onDeclineDialogClose()"
></app-decline-request-popup>

<!-- PrimeNG Dialog for PDF Viewer -->
<p-dialog
  [header]="pdfFileName"
  [(visible)]="displayPdfViewer"
  [modal]="true"
  [style]="{ width: '70vw', height: '80vh' }"
  [draggable]="false"
  [resizable]="false"
  (onHide)="pdfUrl = null"
  styleClass="pdf-viewer-dialog"
>
  <ng-container *ngIf="safePdfUrl as sUrl">
    <iframe
      [src]="sUrl"
      style="width: 100%; height: calc(80vh - 4rem); border: none; background: #1e1e1e;"
      title="PDF preview"
    ></iframe>
  </ng-container>
  <ng-template pTemplate="footer">
    <!-- Optional: Add buttons in the footer if needed -->
  </ng-template>
</p-dialog>